import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initializeClarity } from './services/clarity'

// Initialize Microsoft Clarity (session recordings, heatmaps) when project ID is set in production
initializeClarity()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
